import { render, staticRenderFns } from "./editSubcategory.vue?vue&type=template&id=5ab251c9"
import script from "./editSubcategory.vue?vue&type=script&lang=js"
export * from "./editSubcategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports